import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { actionsHandlers, stateFactories } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialSingleFeatureStateFactory();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const checkPurchaseStatusReducer = createReducer<State, Actions>(initialState, {
  [actions.checkPurchaseStatus.request.type]: actionsHandlers.handleSingleFeatureRequest,
  [actions.checkPurchaseStatus.success.type]: actionsHandlers.handleSingleFeatureSuccess,
  [actions.checkPurchaseStatus.failure.type]: actionsHandlers.handleSingleFeatureFailure,
  [actions.checkPurchaseStatus.reset.type]: actionsHandlers.handleSingleFeatureReset,
  [actions.resetCreatingOrder.type]: actionsHandlers.handleSingleFeatureReset,
});

export default checkPurchaseStatusReducer;
